export const footer = {
  contact: "Contact",
  phone1: "986 369 778",
  phone2: "676 367 580",
  email: "info@gandaraschool.com",
  address1: "Lugar de Moureira, 1, Mañufe",
  address2: "36388 Gondomar (Pontevedra)",
  schedule: "Schedule",
  weekdays: "Monday to Friday",
  hours: "8:15 AM - 5:00 PM",
  follow: "Follow us",
  slogan: "Experiential, trilingual and active learning",
  theSchool: "The School",
  admissions: "Admissions",
  activities: "Activities",
  viewOnMap: "View on Google Maps",
  bookVisitCta: "Book a visit",
  allRightsReserved: "All rights reserved",
  links: {
    aboutUs: "About Us",
    montessori: "Montessori Method",
    trilingual: "Trilingual Education",
    services: "Services",
    extracurriculars: "Extracurriculars",
    admissionProcess: "Admission Process",
    prices: "Prices & Fees",
    visitSchool: "Visit the School",
    openHouse: "Open House",
    birthdays: "Birthdays",
    easterCamp: "Easter Camp",
    summerCamp: "Summer Camp",
    courses: "Courses"
  }
};
